import { render, staticRenderFns } from "./quiz-slice.vue?vue&type=template&id=aa8b1b12&scoped=true&"
import script from "./quiz-slice.vue?vue&type=script&lang=js&"
export * from "./quiz-slice.vue?vue&type=script&lang=js&"
import style0 from "./quiz-slice.vue?vue&type=style&index=0&id=aa8b1b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8b1b12",
  null
  
)

export default component.exports